import {
  DisplayFormErrors,
  MelcoModelsGenericList1MelcoModelsUserProductListItem,
} from "melco-shared-logic";
import { QueryObserverResult } from "react-query";
import { DesignTokens, Row } from "melco-ui";

import { DebugForm } from "../../form/DebugForm";
import { Drawer as DrawerType } from "../../../hooks/drawer/useGenericDrawer";
import { UserProductsAndSupport } from "../UserProductsAndSupport";
import { UserProductTabs } from "../tabs/UserProductTabs";
import { useState } from "react";
import { UserProductsDrawer } from "../drawer/UserProductsDrawer";
import { useGetAllProductsList } from "../../../hooks/product/useGetAllProductsList";

const { spacings } = DesignTokens;

type DisplayUserDetailFormProps = {
  //  userProducts: MelcoModelsGenericList1MelcoModelsUserProductListItem;
  refetch?: () => Promise<
    QueryObserverResult<
      MelcoModelsGenericList1MelcoModelsUserProductListItem,
      unknown
    >
  >;
  selectedUserId: string;
  referencesProductDrawer: DrawerType;
  onCloseProductsDrawer: () => void;
};

export const DisplayUserDetailForm: React.FC<DisplayUserDetailFormProps> = ({
  refetch,
  selectedUserId,
  onCloseProductsDrawer,
  referencesProductDrawer,
}) => {
  const [selectedProductByUser, setSelectedProductByUser] =
    useState<string>("");
  const { data: allProductsList } = useGetAllProductsList();
  //console.log("AllProduct List Parent")
  const onSelectProductByUser = (product: string) => {
    setSelectedProductByUser(product);
  };

  const { isDrawerOpen } = referencesProductDrawer;
  return (
    <>
      <DisplayFormErrors />

      <Row gutter={[spacings.xlarge, spacings.xlarge]}>
        {allProductsList && (
          <UserProductsAndSupport
            userId={selectedUserId}
            onSelectProductByUser={onSelectProductByUser}
            allProducts={allProductsList}
          />
        )}
        {isDrawerOpen && (
          <UserProductsDrawer
            referencesProductDrawer={referencesProductDrawer}
            onCloseProductsDrawer={onCloseProductsDrawer}
            // onSelectProductByUser = {onSelectProductByUser}
            refetch={refetch}
          />
        )}
      </Row>
      <Row gutter={[spacings.xlarge, spacings.xlarge]}>
        {selectedProductByUser && (
          <UserProductTabs
            userId={selectedUserId}
            selectedProduct={selectedProductByUser}
            refetchUserProducts={refetch}
          />
        )}
      </Row>

      {false && <DebugForm />}
    </>
  );
};
